import { render, staticRenderFns } from "./TaskTransferTo.vue?vue&type=template&id=583be97e&scoped=true&"
import script from "./TaskTransferTo.vue?vue&type=script&lang=js&"
export * from "./TaskTransferTo.vue?vue&type=script&lang=js&"
import style0 from "./TaskTransferTo.vue?vue&type=style&index=0&id=583be97e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583be97e",
  null
  
)

export default component.exports